// extracted by mini-css-extract-plugin
export default {"filter_wrapper":"TeamSizeFilter_filter_wrapper__9Yy1r","ts_array":"TeamSizeFilter_ts_array__wIWgg","active":"TeamSizeFilter_active__YK4mS"};